import React, { PureComponent } from "react";
import VolumeChart from "./charts/volume";
import HelpIconButtonWithTooltip from "../../../ui-building-blocks/icons/HelpIconButtonWithTooltip";

class Volume extends PureComponent {
  getDataValue(team_id, key) {
    const { data } = this.props;

    if (!(team_id in data)) {
      return 0;
    }

    if (!(key in data[team_id])) {
      return 0;
    }

    return data[team_id][key] || 0;
  }

  get unitsSold() {
    const { teams } = this.props;
    let data = [];

    Object.keys(teams).forEach(team_id => {
      data.push({
        team: teams[team_id],
        value: Math.abs(this.getDataValue(team_id, "Units Sold"))
      });
    });

    return data;
  }

  get unsoldInventory() {
    const { teams } = this.props;
    let data = [];
    Object.keys(teams).forEach(team_id => {
      data.push({
        team: teams[team_id],
        value:
          Math.abs(this.getDataValue(team_id, "Available For Sale")) -
          Math.abs(this.getDataValue(team_id, "Units Sold"))
      });
    });

    return data;
  }

  get blockHeight() {
    const { teams } = this.props;
    const c = Object.keys(teams).length;
    const h = 152 + 34 * c;

    return h < 330 ? 330 : h;
  }

  get marginStyle() {
    const { teams } = this.props;
    const c = Object.keys(teams).length - 5;
    const c1 = c >= 0 ? c : 0;

    return {
      marginTop: 15 * c1
    };
  }

  render() {
    const { teams } = this.props;

    return (
      <div className="col-md-6">
        <div
          className="bg-white p-30 mh-330"
          style={{ height: this.blockHeight }}
        >
          <h5>
            VOLUME
            <HelpIconButtonWithTooltip
              category="Volume"
              tooltipContent="This section displays the total units that your business produced and sold in relation to your competitors."
              iconSize="sm"
            />
          </h5>
          <hr />
          <div className="row">
            <div
              className="col-md-12 p-0 competitive-analysis-volume-section"
              style={this.marginStyle}
            >
              <VolumeChart
                unsoldInventory={this.unsoldInventory}
                unitsSold={this.unitsSold}
                teams={teams}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Volume;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/volume.js